export default __webpack_public_path__ + "static/media/logo_dark.e1bdf07b.png";